import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import styles from '../Login/style.module.css';
import Logo from '../Login/logowhite.png';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import { resetPassword } from '../../../services/kollectaApi';

const ResetPasswordNew = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get('token') || '';
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [confirmTouched, setConfirmTouched] = useState(false);

  const validatePassword = (password) => {
    if (password.length < 8) return 'A senha deve conter pelo menos 8 caracteres.';
    if (!/[a-z]/.test(password)) return 'A senha deve conter pelo menos 1 letra minúscula.';
    if (!/[A-Z]/.test(password)) return 'A senha deve conter pelo menos 1 letra maiúscula.';
    if (!/[0-9]/.test(password)) return 'A senha deve conter pelo menos 1 número.';
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) return 'A senha deve conter pelo menos 1 caractere especial (ex: @!#$%).';
    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    const passwordError = validatePassword(newPassword);
    if (passwordError) {
      setError(passwordError);
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('As senhas não coincidem.');
      return;
    }

    setLoading(true);

    //

    try {
      await resetPassword({ token: token, newPassword: newPassword });
      setSuccessMessage('Senha atualizada com sucesso!');
      setTimeout(() => {
        navigate('/login');
      }, 1000);
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao atualizar senha');
    }

    setLoading(false);
  };

  const checkRule = (rule) => (rule ? 'green' : 'red');

  const rules = {
    length: newPassword.length >= 8,
    lower: /[a-z]/.test(newPassword),
    upper: /[A-Z]/.test(newPassword),
    number: /[0-9]/.test(newPassword),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(newPassword),
  };

  const showPasswordMismatchError = confirmTouched && confirmPassword !== newPassword;

  return (
    <div className={styles.loginContainer}>
      <div className={styles.left}>
        <img src={Logo} alt="Logo" />
      </div>
      <div className={styles.right}>
        <form className={styles.cardForm} onSubmit={handleSubmit}>
          <div className={styles.cardFormHeader}>
            <h4 className={styles.textInfo}>Recuperar senha</h4>
            <p>Informe abaixo a nova senha de acesso.</p>
          </div>
          <div className={styles.inputsContainer}>

            {/* Nova Senha */}
            <label className={styles.formItem} style={{ position: 'relative' }}>
              Nova Senha *
              <div className={styles.passContainer}>
                <input
                  type={showNewPassword ? 'text' : 'password'}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Digite a nova senha"
                  name="newPassword"
                />
                <button
                  type="button"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  className={styles.passType}
                  aria-label={showNewPassword ? 'Esconder senha' : 'Mostrar senha'}
                >
                  {showNewPassword ? <AiFillEye /> : <AiFillEyeInvisible />}
                </button>
              </div>

              <small
                style={{
                  display: 'block',
                  marginTop: '6px',
                  fontSize: '12px',
                  lineHeight: '1.3',
                  color: '#666',
                }}
              >
                <span style={{ color: checkRule(rules.length) }}>• Pelo menos 8 caracteres;</span><br />
                <span style={{ color: checkRule(rules.lower) }}>• 1 caractere minúsculo;</span><br />
                <span style={{ color: checkRule(rules.upper) }}>• 1 caractere maiúsculo;</span><br />
                <span style={{ color: checkRule(rules.number) }}>• 1 número;</span><br />
                <span style={{ color: checkRule(rules.special) }}>• 1 caractere especial (ex: @!#$%).</span>
              </small>
            </label>

            {/* Confirmar Senha */}
            <label className={styles.formItem} style={{ position: 'relative', marginTop: '1rem' }}>
              Confirmar Senha *
              <div className={styles.passContainer}>
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  onBlur={() => setConfirmTouched(true)}
                  placeholder="Confirme a nova senha"
                  name="confirmPassword"
                />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  className={styles.passType}
                  aria-label={showConfirmPassword ? 'Esconder senha' : 'Mostrar senha'}
                >
                  {showConfirmPassword ? <AiFillEye /> : <AiFillEyeInvisible />}
                </button>
              </div>
              {showPasswordMismatchError && (
                <small style={{ color: 'red', marginTop: '4px', display: 'block' }}>
                  As senhas não coincidem.
                </small>
              )}
            </label>

          </div>

          <button
            type="submit"
            className={styles.btnSubmit}
            disabled={loading || !newPassword || !confirmPassword || newPassword !== confirmPassword}
          >
            {loading ? 'Atualizando...' : 'Salvar senha'}
          </button>

          {error && (
            <div className={styles.errorMessage}>
              <small>{error}</small>
            </div>
          )}

          {successMessage && (
            <div className={styles.successMessage}>
              <small>{successMessage}</small>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordNew;
